
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useToast } from '@/hooks/use-toast';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import BusinessAccountForm, { BusinessAccountFormValues } from '@/components/business/BusinessAccountForm';

const BusinessAccountCreate = () => {
  const { toast } = useToast();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  
  const handleCreateAccount = async (data: BusinessAccountFormValues) => {
    setIsLoading(true);
    
    try {
      console.log('Creating business account with data:', data);
      
      // Simulate API call
      await new Promise(resolve => setTimeout(resolve, 1500));
      
      // Store signup data in session storage to use in the next step
      sessionStorage.setItem('signupData', JSON.stringify({
        name: `${data.firstName} ${data.lastName}`,
        email: data.email,
        company: data.company || '',
        address: data.address,
        city: data.city,
        state: data.state,
        zipCode: data.zipCode,
        country: data.country,
        planId: data.planId,
        billingCycle: data.billingCycle
      }));
      
      toast({
        title: "Account created",
        description: "Your business account has been created. Let's set up your referral program.",
      });
      
      // Redirect to the next step (business onboarding)
      navigate('/business-onboarding');
    } catch (error) {
      console.error('Error creating account:', error);
      toast({
        title: "Error",
        description: error instanceof Error ? error.message : "There was a problem creating your account",
        variant: "destructive",
      });
    } finally {
      setIsLoading(false);
    }
  };
  
  return (
    <div className="min-h-screen flex flex-col">
      <Header isLoggedIn={false} />
      
      <main className="flex-grow py-10 px-4 bg-gray-50">
        <div className="container mx-auto">
          <BusinessAccountForm 
            onSubmit={handleCreateAccount}
            isLoading={isLoading}
          />
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default BusinessAccountCreate;
